import { render, staticRenderFns } from "./collectionTitle.vue?vue&type=template&id=02c5edab&scoped=true&"
import script from "./collectionTitle.vue?vue&type=script&lang=js&"
export * from "./collectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./collectionTitle.vue?vue&type=style&index=0&id=02c5edab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c5edab",
  null
  
)

export default component.exports